import {takeLatest, put, all, call} from 'redux-saga/effects';
import {successToast} from '../actions';
import * as AC from '../actions/actionTypes';
import {
  getCardsByCustomerApi,
  getCardDetailsApi,
  addCardApi,
  reactivateCardApi,
  editCardApi,
  deleteCardApi,
  activateAllCardsApi,
  deactivateAllCardsApi,
  getAllCardsByCustomerApi,
  assingCardsApi,
  getCardsByElevatorApi,
  getOverusedCardsApi,
} from '../api/cards.service';
import history from '../routes/history';
import {errorHandler} from '../utils/errorHandler';
import {getInvalidStatusCardsApi} from '../api/reports.service';

function* getCustomersCardsSaga(fn) {
  try {
    const response = yield call(
      getCardsByCustomerApi,
      fn.customerId,
      fn.filters,
    );
    yield put({
      type: AC.GET_CUSTOMER_CARDS_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_CUSTOMER_CARDS_FAILED);
  }
}

function* getOverusedCardsSaga(fn) {
  try {
    const response = yield call(getOverusedCardsApi, fn.filters);
    yield put({
      type: AC.GET_FREQUENTLY_USED_CARDS_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_CUSTOMER_CARDS_FAILED);
  }
}

function* getAllCustomersCardsSaga(fn) {
  try {
    const response = yield call(getAllCardsByCustomerApi, fn.customerId);
    yield put({
      type: AC.GET_ALL_CUSTOMER_CARDS_SUCCEED,
      payload: response.data,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_ALL_CUSTOMER_CARDS_FAILED);
  }
}

function* getCardDetailsSaga(fn) {
  try {
    const response = yield call(getCardDetailsApi, fn.id);
    yield put({type: AC.GET_CARD_DETAILS_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_CARD_DETAILS_FAILED);
  }
}

function* addCardSaga(fn) {
  try {
    const response = yield call(addCardApi, fn.payload);
    yield put({type: AC.ADD_CARD_SUCCEED, payload: response.data});
    yield put(successToast('Card created successfully!'));
    history.back();
  } catch (e) {
    if (e && e.status === 409) {
      const errorMessage = e.message.error || 'Card conflict occurred!';
      yield put({
        type: AC.ADD_CARD_FAILED,
        payload: errorMessage,
      });
    }
  }
}

function* reactivateCardSaga(fn) {
  try {
    const response = yield call(reactivateCardApi, fn.customerId);
    yield put({
      type: AC.REACTIVATE_CARD_SUCCEED,
      payload: response.data,
      id: fn.cardId,
    });
    yield put(successToast('Cards reactivated for 24hrs!'));
  } catch (e) {
    yield errorHandler(e, AC.REACTIVATE_CARD_FAILED);
  }
}

function* editCardSaga(fn) {
  try {
    const response = yield call(editCardApi, fn.payload);
    yield put({
      type: AC.EDIT_CARD_SUCCEED,
      payload: response.data,
      id: fn.payload.cardId,
    });
    yield put(successToast('Card edited successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.EDIT_CARD_FAILED);
  }
}

function* deleteCardSaga(fn) {
  try {
    const response = yield call(deleteCardApi, fn.cardId);
    yield put({
      type: AC.DELETE_CARD_SUCCEED,
      payload: response.data,
    });
    yield put(successToast('Card deleted successfully!'));
    history.back();
  } catch (e) {
    yield errorHandler(e, AC.DELETE_CARD_FAILED);
  }
}

function* activateAllCardsSaga(fn) {
  try {
    const response = yield call(activateAllCardsApi, fn.customerId);
    yield put({
      type: AC.ACTIVATE_ALL_CARDS_SUCCEED,
      payload: response.data,
    });
    yield put(successToast('All cards activated successfully!'));
    yield put({type: AC.GET_CUSTOMER_CARDS_REQUEST, customerId: fn.customerId});
  } catch (e) {
    yield errorHandler(e, AC.ACTIVATE_ALL_CARDS_FAILED);
  }
}

function* deactivateAllCardsSaga(fn) {
  try {
    const response = yield call(deactivateAllCardsApi, fn.customerId);
    yield put({
      type: AC.DEACTIVATE_ALL_CARDS_SUCCEED,
      payload: response.data,
    });
    yield put(successToast('All cards deactivated successfully!'));
    yield put({type: AC.GET_CUSTOMER_CARDS_REQUEST, customerId: fn.customerId});
  } catch (e) {
    yield errorHandler(e, AC.DEACTIVATE_ALL_CARDS_FAILED);
  }
}

function* assignCardsSaga(fn) {
  try {
    const response = yield call(assingCardsApi, fn.payload);
    yield put({
      type: AC.ASSIGN_CARDS_SUCCEED,
      payload: response.data,
    });
    yield put(successToast('Cards accesses updated successfully!'));
    yield put({type: AC.ASSIGN_CARDS_SUCCEED, customerId: fn.customerId});
  } catch (e) {
    yield errorHandler(e, AC.ASSIGN_CARDS_FAILED);
  }
}

function* getCardsByElevatorSaga(fn) {
  try {
    const response = yield call(
      getCardsByElevatorApi,
      fn.customerId,
      fn.elevatorId,
    );
    yield put({
      type: AC.GET_CARDS_BY_ELEVATOR_SUCCEED,
      payload: response.data,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_CARDS_BY_ELEVATOR_FAILED);
  }
}

function* getInvalidStatusCardsSaga(fn) {
  try {
    const response = yield call(getInvalidStatusCardsApi, fn.filters);
    yield put({
      type: AC.GET_INVALID_STATUS_CARDS_SUCCEED,
      payload: response.data,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_INVALID_STATUS_CARDS_FAILED);
  }
}

function* actionWatcher() {
  yield takeLatest(AC.GET_CUSTOMER_CARDS_REQUEST, getCustomersCardsSaga);
  yield takeLatest(AC.GET_ALL_CUSTOMER_CARDS_REQUEST, getAllCustomersCardsSaga);
  yield takeLatest(
    [AC.GET_CARD_DETAILS_REQUEST, AC.EDIT_CARD_SUCCEED],
    getCardDetailsSaga,
  );
  yield takeLatest(AC.GET_FREQUENTLY_USED_CARDS_REQUEST, getOverusedCardsSaga);
  yield takeLatest(
    AC.GET_INVALID_STATUS_CARDS_REQUEST,
    getInvalidStatusCardsSaga,
  );
  yield takeLatest(AC.ADD_CARD_REQUEST, addCardSaga);
  yield takeLatest(AC.REACTIVATE_CARD_REQUEST, reactivateCardSaga);
  yield takeLatest(AC.EDIT_CARD_REQUEST, editCardSaga);
  yield takeLatest(AC.DELETE_CARD_REQUEST, deleteCardSaga);
  yield takeLatest(AC.ACTIVATE_ALL_CARDS_REQUEST, activateAllCardsSaga);
  yield takeLatest(AC.DEACTIVATE_ALL_CARDS_REQUEST, deactivateAllCardsSaga);
  yield takeLatest(AC.ASSIGN_CARDS_REQUEST, assignCardsSaga);
  yield takeLatest(AC.GET_CARDS_BY_ELEVATOR_REQUEST, getCardsByElevatorSaga);
}

export default function* cardsSaga() {
  yield all([actionWatcher()]);
}
